import React from "react";

function Calendar(props: any) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      {...props}
    >
      <g clipPath="url(#clip0_2234_35466)">
        <path
          d="M14.85 1.66667V1.81667H15H17.5C18.1233 1.81667 18.721 2.06426 19.1617 2.50497C19.6024 2.94568 19.85 3.54341 19.85 4.16667V19.85H0.15V4.16667C0.15 3.54341 0.397589 2.94568 0.838299 2.50497C1.27901 2.06426 1.87674 1.81667 2.5 1.81667H5H5.15V1.66667V0.15H6.51667V1.66667V1.81667H6.66667H13.3333H13.4833V1.66667V0.15H14.85V1.66667ZM18.3333 6.81667H18.4833V6.66667V4.16667C18.4833 3.90587 18.3797 3.65576 18.1953 3.47135C18.0109 3.28693 17.7608 3.18333 17.5 3.18333H2.5C2.2392 3.18333 1.98909 3.28693 1.80468 3.47135C1.62027 3.65576 1.51667 3.90587 1.51667 4.16667V6.66667V6.81667H1.66667H18.3333ZM1.51667 18.3333V18.4833H1.66667H18.3333H18.4833V18.3333V8.33333V8.18333H18.3333H1.66667H1.51667V8.33333V18.3333Z"
          fill="#666666"
          stroke="white"
          strokeWidth="0.3"
        />
        <path
          d="M12.65 12.3502V10.9835H14.0167V12.3502H12.65Z"
          fill="#666666"
          stroke="white"
          strokeWidth="0.3"
        />
        <path
          d="M9.31602 12.3502V10.9835H10.6827V12.3502H9.31602Z"
          fill="#666666"
          stroke="white"
          strokeWidth="0.3"
        />
        <path
          d="M5.98398 12.3502V10.9835H7.35065V12.3502H5.98398Z"
          fill="#666666"
          stroke="white"
          strokeWidth="0.3"
        />
        <path
          d="M12.65 15.6832V14.3165H14.0167V15.6832H12.65Z"
          fill="#666666"
          stroke="white"
          strokeWidth="0.3"
        />
        <path
          d="M9.31602 15.6832V14.3165H10.6827V15.6832H9.31602Z"
          fill="#666666"
          stroke="white"
          strokeWidth="0.3"
        />
        <path
          d="M5.98398 15.6832V14.3165H7.35065V15.6832H5.98398Z"
          fill="#666666"
          stroke="white"
          strokeWidth="0.3"
        />
      </g>
      <defs>
        <clipPath id="clip0_2234_35466">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Calendar;
